/* eslint global-require: "off" */

import React, { Component } from 'react';

// import Helmet from 'react-helmet';
import { connect } from 'react-redux';
// import ReactKalturaResumableJs from 'react-kaltura-resumablejs';
import { asyncConnect } from 'redux-connect';
import { Link } from 'react-router';

import { bindActionCreators } from 'redux';

import ApplyCSS from '../../components/ApplyCSS';
import KalturaFileUpload from '../../components/KalturaFileUpload';


import TemplateOne from './components/TemplateOne';
import TemplateTwo from './components/TemplateTwo';

// import Accordion from '../../components/ZUILib/Accordion';
import * as labelsActions from '../../components/labels/actions';
// import * as getGlobleObject from '../../components/globleObject/reducer';

import * as createEventObject from '../createEvent/actions';


import commonUtil from '../../utils/commonUtil';

import { getBrowserBunyanInstance } from '../../utils/clientLoggerHandler';
import { constDownload, constPrint } from '../../utils/clientConstant';

// import asyncProvider from '../../utils/AsyncProvider';

const B64 = require('base64-encode-decode');

const applicationRoutes = commonUtil.getApplicationRoutes();

const { eventStrategy, eventSteps } = require('../createEvent/eventStep');

const loggerHandler = getBrowserBunyanInstance('Template');

const { isLablesLoaded, loadLables } = labelsActions;
const { isCreateEventDataLoaded, getSaveCreateEventData, defineCreateEventData } = createEventObject;

const pageName = 'templatePage';


// @asyncConnect(asyncProvider.getAsyncFor([
//   { deferred: true, loadChecker: isLablesLoaded, loadMethod: loadLables },
//   { deferred: true, loadChecker: isCreateEventDataLoaded, loadMethod: getSaveCreateEventData, data: ['templatePage', 'Initial Load'] },
// ]))


@asyncConnect([{
  // deferred: true,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
}, {
  // deferred: true,
  promise: ({ store: { dispatch, getState } }) => {
    const globalState = getState();
    if (!isCreateEventDataLoaded(getState(), pageName)) {
      return dispatch(defineCreateEventData(pageName, 'Initial Load'));
    }
    return undefined;
  },
},
])

class Template extends Component {
  constructor() {
    super();
    this.pageSubmit = this.pageSubmit.bind(this);
    getSaveCreateEventData();
    this.state = {
      uploader: '',
      showMyTemplate: true,
    };
  }
  downloadToPDF = (param) => {
    if (param && param === constDownload) {
      window.open(applicationRoutes.downloadToPDF + '?pageName=' + pageName + '&content=' + param + '', '_blank', 'width=1000,height=500');
    } else if (param && param === constPrint) {
      window.open(applicationRoutes.downloadToPDF + '?pageName=' + pageName + '&content=' + param + '', 'PRINT', '_blank', 'height=400,width=600');
    }
  }
  pageSubmit(e) {
    const a = this.state.showMyTemplate;
    const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow

    defineCreateEventData('templatePage', this._txtUserName.value);
    // return dispatch(getSaveCreateEventData('templatePage', getState(), 'Initial Load'));
  }

  state = {
    showMyTemplate: false,
  }

  handleToggleKitten = () => this.setState({ showMyTemplate: !this.state.showMyTemplate })
  onFileSuccess = (response) => {
    console.log(response); // console required
  };

  onFileRemoved = (file) => {
    console.log(file); // console required
  };
  onError = (error) => {
    console.log(error); // console required
  }; 

  onFileSuccess = (data) => {
    console.log('MSG I am here', data.thumbnailUrl); // console required
  }
  render() {
    const { error, lables, createEvent } = this.props;
    if (!lables) {
      return null;
    } else if (error) {
      return null;  // Error from Service...........
    }
    const stream = 'IntcImZpcnN0TmFtZVwiOlwiQmFsYW11cnVnYW5cIixcImxhc3ROYW1lXCI6XCJEZXZhcmFqYW5cIixcImV2ZW50RGV0YWlsc1wiOltdLFwicmVkaXJlY3RUb0NoYW5nZVBhc3N3b3JkXCI6XCJOb1wiLFwicHJvZmlsZUlkXCI6XCI1MzY3ODAwMDFcIixcIm1pZGRsZU5hbWVcIjpcIkJNXCIsXCJlbWFpbElkXCI6XCJiZGV2YXJhamFuQHplbnNhci5jb21cIixcImxpbmtzXCI6W3tcIm1ldGhvZFwiOlwiR0VUXCIsXCJyZWxcIjpcInNlbGZcIixcImhyZWZcIjpcImh0dHA6Ly9ncmRldi5saXZlcnBvb2wuY29tLm14OjMwMDAvcHVibGljL3YxL2N1cnJlbnRVc2VyL2xvZ2luXCJ9LHtcIm1ldGhvZFwiOlwiR0VUXCIsXCJyZWxcIjpcImNhbm9uaWNhbFwiLFwiaHJlZlwiOlwiaHR0cDovL2dyZGV2LmxpdmVycG9vbC5jb20ubXg6MzAwMC9wdWJsaWMvdjEvY3VycmVudFVzZXIvbG9naW5cIn1dLFwic3RhdHVzXCI6e1wic3RhdHVzXCI6XCJzdWNjZXNzXCJ9fSI=';

    return (

      <div className="container-fluid" >

        <div>
          <KalturaFileUpload onFileSuccess={this.onFileSuccess} />
          -------------------------------------------------------------
        </div>
        This data is getting from lables:: {commonUtil.getLabel(lables.ContactUs, 'contact.form.subhead.label')}
        <ApplyCSS pageName="selectMesaType" />
        <TemplateOne />
        <TemplateTwo DataFrmMainpage={this.state.showMyTemplate} />
        <input type="text" name="txtUserName" ref={(txtUserName) => { this._txtUserName = txtUserName; }} />
        <input type="text" name="txtUserFName" />

        <button value="test" onClick={this.pageSubmit}>Click me for Test</button>
        I am {createEvent.templatePage}
        <Link to="/createEvent/SelectMesaType">SelectMesaType</Link>

        <div className="col-sm-3 buttonsPdf">
          <span className="icon-imprimir" onClick={() => this.downloadToPDF(constPrint)} />
          {/* <a href="" id="downloadLink"><span className="icon-importar" onClick={() => { this.downlLoadTheContract(contractPage.contractDetailsInfo.contractdata); }} /></a> */}
          <a id="downloadLink"><span className="icon-importar" onClick={() => this.downloadToPDF(constDownload)} /></a>
        </div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  createEvent: state.createEventObject.data,
  state,
  info: state.info,
});

const matchDispatchToProps = dispatch => bindActionCreators({ defineCreateEventData }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Template);
